import { render, staticRenderFns } from "./CreditClassTeacherSave.vue?vue&type=template&id=0b1f8354&"
import script from "./CreditClassTeacherSave.vue?vue&type=script&lang=js&"
export * from "./CreditClassTeacherSave.vue?vue&type=script&lang=js&"
import style0 from "./CreditClassTeacherSave.vue?vue&type=style&index=0&id=0b1f8354&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports